// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"31d6cfe0","193":"340bb0ba","201":"e43f1f40","241":"daabdbfe","940":"7e20d02d"}[chunkId] + ".chunk.css";
};